<template>
    <li
        :class="classes"
        @click.stop="select"
        @mousedown.prevent
    ><slot>{{ showLabel }}</slot></li>
</template>
<script>
import Emitter from '@/business/emitter'
import { findComponentUpward } from '@/business/utils'

const prefixCls = 'ivu-select-item'

export default {
  name: 'AbOption',
  componentName: 'select-item',
  mixins: [ Emitter ],
  props: {
    value: {
      type: [String, Number],
      required: true
    },
    label: {
      type: [String, Number]
    },
    disabled: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    isFocused: {
      type: Boolean,
      default: false
    },
    showLogo: {
      type: Boolean,
      default: false
    },
    logoUrl: {
      type: String
    }
  },
  data () {
    return {
      searchLabel: '', // the slot value (textContent)
      autoComplete: false
    }
  },
  computed: {
    classes () {
      return [
        `${prefixCls}`,
        {
          [`${prefixCls}-disabled`]: this.disabled,
          [`${prefixCls}-selected`]: this.selected && !this.autoComplete,
          [`${prefixCls}-focus`]: this.isFocused
        }
      ]
    },
    showLabel () {
      return (this.label) ? this.label : this.value
    },
    optionLabel() {
      return this.label || (this.$el && this.$el.textContent)
    }
  },
  methods: {
    select () {
      if (this.disabled) return false

      this.dispatch('AbSelect', 'on-select-selected', {
        value: this.value,
        label: this.optionLabel,
        showLogo: this.showLogo,
        logoUrl: this.logoUrl
      })
      this.$emit('on-select-selected', {
        value: this.value,
        label: this.optionLabel,
        showLogo: this.showLogo,
        logoUrl: this.logoUrl
      })
    }
  },
  mounted () {
    const Select = findComponentUpward(this, 'AbSelect')
    if (Select) this.autoComplete = Select.autoComplete
  }
}
</script>
<style lang="scss" scoped>
.ivu-select-item-selected, .ivu-select-item-selected:hover {
  background: #F0F4F8;
}
</style>
